import { createContext, ReactNode, useState } from 'react';

import ContactModal from 'components/ContactModal';

export interface ContactModalContext {
  openModal: (message: string) => void;
  closeModal: () => void;
}

interface ContactModalContextProps {
  children: ReactNode;
}

export const ContactModalContext = createContext<ContactModalContext>({
  openModal: () => {},
  closeModal: () => {},
});

export const ContactModalProvider = ({
  children,
}: ContactModalContextProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contactModalMessage, setModalMessage] = useState('');

  const openModal = (message: string) => {
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalMessage('');
    setIsModalOpen(false);
  };

  return (
    <ContactModalContext.Provider
      value={{
        openModal,
        closeModal,
      }}
    >
      {children}
      {isModalOpen && <ContactModal message={contactModalMessage} />}
    </ContactModalContext.Provider>
  );
};
